<template>
    <div>
        <v-layout row wrap align-center justify-center>
              <v-flex xs12 sm7 md7>
                  <dialogos-app :dialogos="dialogosB" tucan="0"></dialogos-app>
              </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-1 pb-5 text-xs-center class="cont_page">
            <v-flex xs12 sm7 md7>
                <div class="item-btn-modal btn-blue-light hvr hvr" :class="{'btnexpandvisto':vistosExpand[0]}" @click="expand = !expand , mostrarContenido(0), expandB = false">
                    <span>{{titulosList[0]}}</span>
                    <v-icon class="icon" size="30" color="#0067AD" :class="{'icon-active':expand}">navigate_next</v-icon>
                </div>
                <audio-player ref="audioPlayerA" :audios="textosListA.audio"></audio-player> 
                <v-expand-transition>
                <div class="cont-item-modal" v-show="expand">
                    <ul>
                        <div v-for="i in 4" :key="'itemli'+i">
                            <li>{{textosListA.texto[i-1]}}</li>
                            <li> <button class="li-btn-green hvr-scale" @click="escucharA(i)">
                                {{textosListA.boton[i-1]}}
                                <v-icon class="icon" size="30" color="white" v-if="btnActiveA[i]">volume_up</v-icon>
                                </button>
                            </li>
                        </div>
                    </ul>
                </div>
                </v-expand-transition>
            </v-flex>
            <v-flex xs12 sm7 md7 mt-2>
                <div class="item-btn-modal btn-blue-light hvr hvr" :class="{'btnexpandvisto':vistosExpand[1]}" @click="expandB = !expandB , mostrarContenido(1) ,expand = false">
                    <span>{{titulosList[1]}}</span>
                    <v-icon class="icon" size="30" color="#0067AD" :class="{'icon-active':expandB}">navigate_next</v-icon>
                </div>
                <audio-player ref="audioPlayerB" :audios="textosListB.audio"></audio-player> 
                <v-expand-transition>
                <div class="cont-item-modal " v-show="expandB">
                    <ul>
                        <div v-for="i in 4" :key="'itemli'+i">
                            <li>{{textosListB.texto[i-1]}}</li>
                            <li> <button class="li-btn-orange hvr-scale" @click="escucharB(i)">
                                {{textosListB.boton[i-1]}}
                                <v-icon class="icon" size="30" color="white" v-if="btnActiveB[i]">volume_up</v-icon>
                                </button>
                            </li>
                        </div>
                    </ul>
                </div>
                </v-expand-transition>
            </v-flex>
        </v-layout>        
    </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
    mixins: [nextConditions],
    data(){
        return {
            dialogosB:[
                'Em português, há várias formas de responder afirmativa ou negativamente.',
                'Clique nos exemplos destacados e escute a pronúncia.',
                'Agora, clique em avançar e vá em frente.'
            ],
            contVisto:Array(2).fill(false),
            btnActive:false,
            titulosList:['Respostas afirmativas','Respostas negativas'],
            textosListA:{
                texto:['Verbo, sim','Sim, verbo','Verbo','Só afirmação'],
                boton:['Estou, sim',' Sim, estou','Estou','Sim'],
                audio:['slide5/Estou, sim','slide5/Sim, estou','slide5/Estou','slide5/Sim']
            },
            textosListB:{
                texto:['Não, não verbo','Não, verbo não','Não verbo','Só a negação'],
                boton:['Não, não estou','Não, estou não','Não estou','Não'],
                audio:['slide5/Nao, nao estou','slide5/Nao, estou nao','slide5/Nao estou','slide5/Nao']
            },
            btnActiveA:Array(4).fill(false),
            btnActiveB:Array(4).fill(false),
            expand: false,
            expandB: false,
            vistos:Array(8).fill(false),
            vistosExpand:Array(2).fill(false)
        }
    },
    methods: {
        mostrarContenido(val){
            this.contVisto = Array(2).fill(false)
            this.$set(this.contVisto,val,true)
            this.$set(this.vistosExpand,val,true)
        },
        escucharA(val){
            this.$refs.audioPlayerA.playAudio(val-1)
            this.btnActiveA = Array(4).fill(false)
            this.$set(this.btnActiveA,val,true)
            this.$set(this.vistos,val-1,true)
        },
        escucharB(val){
            this.$refs.audioPlayerB.playAudio(val-1)
            this.btnActiveB = Array(4).fill(false)
            this.$set(this.btnActiveB,val,true)
            this.$set(this.vistos,val+3,true)
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';
.item-btn-modal{
    color: #0067AD;
    border-radius: 4px 0px;
    position: relative;
    span{
        font-size: 15px;
        margin-right: 10px;
    }
    .icon{
    float:right;
    position: absolute;
    right: 0px;
    top: 20%;
    transition: all 0.3s ease-out;
    transform: rotate(0deg);
    }
    span{
        font-family: Poppins-Bold;
        color: black;
    }
}
.icon-active{
    transform: rotate(90deg)!important;
}
.cont-item-modal{
    padding: 5px 0px;
    transition:all 0.4s ease-out;
    padding: 18px;
    outline: none;
    border-radius: 0px 4px;
    ul{
        list-style: none;
        text-align: center;
        margin: 0;
        padding: 0;
        li{
            list-style: none;
            margin: 0;
            padding: 0;
        }
    }
}
.cont-visto{
    display: block;
}
.li-btn-green{
    background: #5A8B34;
    width: auto;
    padding: 5px 10px;
    border-radius: 4px;
    color: white;
}
.li-btn-orange{
    background: #CD4036;
    width: auto;
    padding: 5px 10px;
    border-radius: 4px;
    color: white;
}
</style>